var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportContactsOutlookFilledCheck24PxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled_check_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2ca819"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M18.677,6,8.587,16.09,4,11.5",
    transform: "translate(-2.339 -2.045)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 18,
    height: 18,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportContactsOutlookFilledCheck24PxIcon);
export default __webpack_public_path__ + "static/media/import-contacts-outlook-Filled_check_24px-icon.cc091d1a4d3cb2e168963f69802cf8c4.svg";
export { ForwardRef as ReactComponent };